import { motion } from "framer-motion";

const STATS = [
  { icon: "/legal-icon-1.svg", value: "50+", label: "Legal Transactions Advised" },
  { icon: "/legal-icon-2.svg", value: "$3 Billion+", label: "Deal Value Advised" },
  { icon: "/legal-icon-3.svg", value: "20+", label: "Countries" },
  { icon: "/legal-icon-4.svg", value: "3000+", label: "People Trained" },
];

const container = { hidden: {}, visible: { transition: { staggerChildren: 0.12 } } };
const item = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

export const TrustedStats = () => {
  return (
    <section data-testid="trusted-stats-section" className="bg-[#FBEDE7] py-10 md:py-12">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-12 bg-gold" />
          <span className="font-sans text-[11px] tracking-[0.28em] uppercase text-forest">
            Track Record
          </span>
        </div>
        <h2 className="font-serif text-[21px] md:text-[25px] lg:text-[34px] text-charcoal leading-tight mb-6">
          Trusted. Proven. Delivered.
        </h2>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "0px 0px -80px 0px" }}
          className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-8"
        >
          {STATS.map((s) => (
            <motion.div key={s.label} variants={item} data-testid="trusted-stat" className="flex flex-col">
              <img src={s.icon} alt="" aria-hidden="true" className="w-[36px] h-[36px] md:w-[43px] md:h-[43px] object-contain" />
              <span className="mt-6 font-serif text-[17px] md:text-[21px] lg:text-[25px] text-charcoal leading-none">
                {s.value}
              </span>
              <span className="mt-3 font-sans text-[9px] md:text-[10px] tracking-[0.14em] uppercase text-charcoal/50">
                {s.label}
              </span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
